import Swiper from 'swiper/bundle';
import(/* webpackPrefetch: true */ "swiper/swiper-bundle.min.css");

export default Swiper;
